module.exports = __webpack_public_path__ + "static/img/map.066e46da.png";